"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAMPLE_DATA = exports.DEFAULT_COLOR = void 0;
var SAMPLE_DATA = [{
  disclaimerText:
  // eslint-disable-next-line max-len
  'Flights operated by AirAsia cannot be canceled once successfully booked, but change is allowed under limited conditions by paying certain fee. For details, please refer to <a target="_blank" href="{0}">Fare Rules</a>; Free checked baggage and meals are not included in Economy Class (including Low-fare). You can purchase them in advance on this page or via "Manage My Booking".',
  links: ['https://www.airasia.cn/aa/about-us/en/gb/fares.html']
}, {
  disclaimerText:
  // eslint-disable-next-line max-len
  'By clicking "Continue", you will be redirected from the airasia.cn website to the oversea website, airasia.com. And your final transaction will take place on the airasia.com website. airasia.com website is exclusively belongs to Malaysia AirAsia Com Travel Sdn Bhd, and your transaction is a direct contractual relationship with the company. Please note that the airasia.com website has its own terms of use and privacy policy.'
}];
exports.SAMPLE_DATA = SAMPLE_DATA;
var DEFAULT_COLOR = {
  iconColor: 'yellow'
};
exports.DEFAULT_COLOR = DEFAULT_COLOR;